import { IDefer } from "src/constants/interfaces";
import { useTranslation } from "src/hooks/translation";

interface IProps {
    defer: IDefer<boolean>;
};

const LeaveEditingPopup = ({ defer }: IProps) => {
    const t = useTranslation();

    return (
        <div className="B-popup-content B-popup-small">
            <h3 className="B-popup-title">{t('Leave editing')}</h3>
            <div className="B-popup-main-content">
                <i className="global-icon icon-action-edit B-edit-icon"/>
                <p className="text-center">{t('Are you sure you want to leave bet editing')}?</p>
            </div>

            <button className="B-popup-cancel-button" onClick={() => defer.resolve(false)}>{t('No')}</button>
            <button className="B-popup-confirm-button" onClick={() => defer.resolve(true)}>{t('Yes')}</button>
        </div>
    );
};

export default LeaveEditingPopup;